import {
  avatar,
  background,
  captions,
  frame,
  host,
  speaker,
  text,
  visualizer,
} from './helpers'
import type { TemplateBlueprint } from './types'

/**
 * `ChatboxLayout` (`layouts/ChatboxLayout.tsx`): the episode on top, a
 * speech box (a 1 px outline at half opacity) holding the captions over
 * bars, the speaker at the foot. Two title lines in portrait, one
 * elsewhere. Intended differences: the speech-bubble tail (two stacked
 * triangles) is not drawn — v2 has no triangle primitive.
 */
const bars = { variant: 'equalizer' as const }
const handle = { weight: 400, lineHeight: 1.3 }

export const chatboxBlueprint: TemplateBlueprint = {
  kind: 'audio',
  orientations: {
    portrait: [
      background(),
      host('portrait', 60, 60, 165, 'rect'),
      text('portrait', 'title', [275, 60, 745, 110], {
        size: 36,
        weight: 600,
        lineHeight: 1.52,
      }),
      text('portrait', 'subtitle', [275, 170, 745, 55], {
        size: 36,
        weight: 500,
        lineHeight: 1.52,
      }),
      frame('portrait', 'box', [60, 298, 960, 1342], 1),
      captions('portrait', [140, 378, 800, 862], 'start'),
      visualizer('portrait', [140, 1240, 800, 320], bars),
      avatar('portrait', 60, 1790, 70),
      {
        ...speaker('portrait', [167, 1798, 700, 55], 'handle', {
          size: 42,
          ...handle,
        }),
        id: 'speaker',
      },
    ],
    square: [
      background(),
      host('square', 50, 50, 136, 'rect'),
      text('square', 'title', [220, 66, 810, 52], {
        size: 34,
        weight: 600,
        lineHeight: 1.52,
      }),
      text('square', 'subtitle', [220, 118, 810, 52], {
        size: 34,
        weight: 500,
        lineHeight: 1.52,
      }),
      frame('square', 'box', [50, 234, 980, 616], 1),
      captions('square', [110, 294, 860, 256], 'start'),
      visualizer('square', [110, 550, 860, 240], bars),
      avatar('square', 50, 960, 70),
      {
        ...speaker('square', [157, 973, 700, 44], 'handle', {
          size: 34,
          ...handle,
        }),
        id: 'speaker',
      },
    ],
    landscape: [
      background(),
      host('landscape', 60, 60, 165, 'rect'),
      text('landscape', 'title', [275, 85, 1585, 58], {
        size: 38,
        weight: 600,
        lineHeight: 1.52,
      }),
      text('landscape', 'subtitle', [275, 143, 1585, 58], {
        size: 38,
        weight: 500,
        lineHeight: 1.52,
      }),
      frame('landscape', 'box', [60, 271, 1800, 599], 1),
      captions('landscape', [141, 352, 1638, 246], 'start'),
      visualizer('landscape', [140, 598, 1640, 200], bars),
      avatar('landscape', 60, 950, 70),
      {
        ...speaker('landscape', [167, 958, 700, 55], 'handle', {
          size: 42,
          ...handle,
        }),
        id: 'speaker',
      },
    ],
  },
}
